import { NavLink, Outlet } from 'react-router-dom'

import { useSessao } from '../stores/sessao'
import { useTema, type Tema } from '../stores/tema'
import { Botao } from './Botao'
import estilos from './Layout.module.css'

type Item = { para: string; rotulo: string; exigePermissao?: boolean }

const TERRA_BRASIL: Item[] = [
  { para: '/terra-brasil', rotulo: 'Shopping de preços' },
  { para: '/favoritos', rotulo: 'Favoritos' },
]

const INGESTAO: Item[] = [
  { para: '/uploads', rotulo: 'Uploads' },
  { para: '/pendencias', rotulo: 'Pendências' },
  { para: '/de-paras', rotulo: 'De-paras', exigePermissao: true },
]

const ADMIN: Item[] = [{ para: '/usuarios', rotulo: 'Usuários' }]

const ROTULO_TEMA: Record<Tema, string> = {
  sistema: 'Tema: sistema',
  claro: 'Tema: claro',
  escuro: 'Tema: escuro',
}

const PROXIMO_TEMA: Record<Tema, Tema> = {
  sistema: 'claro',
  claro: 'escuro',
  escuro: 'sistema',
}

export function Layout() {
  const usuario = useSessao((estado) => estado.usuario)
  const sair = useSessao((estado) => estado.sair)
  const { tema, definir } = useTema()

  // A edição de de-paras exige `pode_ingerir` no backend. Esconder o link de
  // quem não tem a permissão evita oferecer uma tela que só devolveria 403 —
  // mas a decisão continua sendo do servidor; isto é cortesia, não segurança.
  const itensIngestao = INGESTAO.filter(
    (item) => !item.exigePermissao || usuario?.podeIngerir || usuario?.isStaff,
  )

  return (
    <div className={estilos.moldura}>
      <aside className={estilos.barra}>
        <div className={estilos.marca}>
          <span className={estilos.marcaTitulo}>Análise de Pricing</span>
          <span className={estilos.marcaSub}>Booker Brasil</span>
        </div>

        <nav className={estilos.nav} aria-label="Seções">
          <span className={estilos.grupo}>Terra Brasil</span>
          {TERRA_BRASIL.map((item) => (
            <Elo key={item.para} {...item} />
          ))}

          <span className={estilos.grupo}>Ingestão</span>
          {itensIngestao.map((item) => (
            <Elo key={item.para} {...item} />
          ))}

          {usuario?.isStaff && (
            <>
              <span className={estilos.grupo}>Administração</span>
              {ADMIN.map((item) => (
                <Elo key={item.para} {...item} />
              ))}
            </>
          )}
        </nav>

        <div className={estilos.rodape}>
          <button
            type="button"
            className={estilos.tema}
            onClick={() => definir(PROXIMO_TEMA[tema])}
          >
            {ROTULO_TEMA[tema]}
          </button>
          <div className={estilos.usuario}>
            <span className={estilos.usuarioNome}>{usuario?.nome}</span>
            <span className={estilos.usuarioPapel}>
              {usuario?.podeIngerir || usuario?.isStaff ? 'Pode enviar planilhas' : 'Somente leitura'}
            </span>
          </div>
          <Botao variante="sutil" tamanho="pequeno" onClick={() => void sair()}>
            Sair
          </Botao>
        </div>
      </aside>

      <main className={estilos.conteudo}>
        <Outlet />
      </main>
    </div>
  )
}

function Elo({ para, rotulo }: Item) {
  return (
    <NavLink
      to={para}
      className={({ isActive }) => `${estilos.elo} ${isActive ? estilos.eloAtivo : ''}`}
    >
      {rotulo}
    </NavLink>
  )
}
